import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularWindow: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_window"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="window icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 28 28"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M6.75 3H21.25C23.3211 3 25 4.67893 25 6.75V21.25C25 23.3211 23.3211 25 21.25 25H6.75C4.67893 25 3 23.3211 3 21.25V6.75C3 4.67893 4.67893 3 6.75 3ZM4.5 9.5V21.25C4.5 22.4926 5.50736 23.5 6.75 23.5H21.25C22.4926 23.5 23.5 22.4926 23.5 21.25V9.5H4.5ZM23.5 8V6.75C23.5 5.50736 22.4926 4.5 21.25 4.5H6.75C5.50736 4.5 4.5 5.50736 4.5 6.75V8H23.5Z" />
      </svg>
    </span>
  );
};

export { RegularWindow };
